const styles = {
  container: {
    display: 'flex',
    overflowX: 'auto',
    height: '80vh',
    padding: 2,
    gap: 2,
    '&::-webkit-scrollbar': { display: 'none' },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
  },
  stepContainer: {
    minWidth: 400,
    maxWidth: 400,
    maxHeight: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    '&::-webkit-scrollbar': { display: 'none' },
    msOverflowStyle: 'none',
    scrollbarWidth: 'none',
  },
  header: {
    position: 'sticky',
    top: 0,
    backgroundColor: 'primary.main',
    zIndex: 1,
    padding: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  fabContainer: {
    flexDirection: 'column',
    position: 'fixed',
    display: 'flex',
    bottom: 20,
    right: 20,
    gap: 2,
  },
  leadPaper: {
    mx: 2,
    padding: 1,
    backgroundColor: '#f4f4f4',
    display: 'flex',
    flexDirection: 'column',
  },
  badge: {
    position: 'absolute',
    top: 8,
    right: 8,
    zIndex: 1300,
  },
  modal: {
    gap: 2,
    display: 'flex',
    flexDirection: 'column',
  },
  modalScroll: {
    maxHeight: '50vh',
    overflowY: 'auto',
  },
  modalCard: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
  modalCardContent: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'start',
  },
};

export default styles;
